import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { ReactNode } from "react";

type ProgressIndexCircleProps = {
  label: ReactNode;
  value: number;
  isCompleted?: boolean;
  size?: number | string;
  thickness?: number;
};

export function ProgressIndexCircle({
  label,
  value,
  isCompleted = false,
  size = "2rem",
  thickness = 3
}: ProgressIndexCircleProps) {
  const theme = useTheme();
  const normalizedValue = Math.min(100, Math.max(0, value));

  return (
    <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
      <CircularProgress
        variant="determinate"
        value={ 100 }
        size={ size }
        thickness={ thickness }
        sx={ {
          color: theme.customColors.border,
          position: "absolute"
        } }
      />
      <CircularProgress
        variant="determinate"
        value={ isCompleted ? 100 : normalizedValue }
        size={ size }
        thickness={ thickness }
        sx={ {
          color: isCompleted || normalizedValue > 0
            ? theme.customColors.borderSecondaryComplete
            : "transparent"
        } }
      />
      <Box
        position="absolute"
        top={ 0 }
        right={ 0 }
        bottom={ 0 }
        left={ 0 }
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          component="span"
          fontWeight={ 600 }
          fontSize="1rem"
          color={ theme.customColors.exploreCardText }
          lineHeight={ 1 }
        >
          { label }
        </Typography>
      </Box>
    </Box>
  );
}


